export { default } from "bullitttime-embermodelsgochips/models/translation";
